export const apiConstants = {
  url: "/api/country"
};
